import { Box, Button, Flex, Icon, Stack, Text } from "@chakra-ui/react";
import { FiEdit3, FiTrash2 } from "react-icons/fi";
import { RiRoadMapLine } from "react-icons/ri";

type EnderecoData = {
	id: string;
	cep: string;
	uf: string;
	cid: string;
	cidcod: string;
	bai: string;
	endereco: string;
	num: string;
	comp: string;
	ponto_ref: string;
	emp_cod: string;
}
type EnderecoItemProps ={
	endereco: EnderecoData;
	setEndModal: (end: EnderecoData) => void;
	setIsNewEndClienteModal: (isOpen: boolean) => void;
	enderecos: EnderecoData[];
	setEnderecos: (enderecos: EnderecoData[]) => void;
}

const EnderecoItem: React.FC<EnderecoItemProps> = ({ 
	endereco,
	setEndModal,
	setIsNewEndClienteModal,
	enderecos,
	setEnderecos,
}) => {
	function handleDeleteEnd() {
		const endIndex = enderecos.findIndex(end => end.id === endereco.id);
		enderecos.splice(endIndex, 1);
		setEnderecos([...enderecos]);
	}

	return (
		<Stack 
			direction="row"
			justify="space-between"
			align="center"
			bg="gray.40"
			borderColor="gray.100"
			borderWidth={1}
			borderRadius={8}
			py="2"
			px="4"
			_hover={{ boxShadow: 'lg' }}
		>
			<Flex
				w="100%"
				align="center"
				cursor="pointer"
				onClick={() => {
					setEndModal(endereco);
					setIsNewEndClienteModal(true);
				}}
			>
				<Icon as={RiRoadMapLine} fontSize="26" mr="4" color="gray.600" />
				<Box>
					<Text color="gray.600" fontSize="15">{endereco.endereco}, {endereco.num}</Text>
					<Text color="gray.500" fontSize="14">
						{endereco.comp ? `${endereco.comp}, ` : ''}{endereco.bai}, {endereco.cid} - {endereco.uf}
						{endereco.ponto_ref ? ` - ${endereco.ponto_ref}` : ''}
					</Text>
				</Box>
			</Flex>

			<Stack direction="row" spacing={4}>
				<Icon
					as={FiEdit3}
					color="blue.400"
					w={6}
					h={6}
					cursor="pointer"
					onClick={() => {
						setEndModal(endereco);
						setIsNewEndClienteModal(true);
					}}
				/>

				<Icon
					as={FiTrash2} 
					color="red.500"
					w={6}
					h={6}
					cursor="pointer"
					onClick={handleDeleteEnd}
				/>

				{/* <Button
					size="sm"
					bg="transparent"
					_hover={{ bg: 'transparent' }}
					onClick={() => {
						setEndModal(endereco);
						setIsNewEndClienteModal(true);
					}}
				>
					<Icon as={FiEdit3} fontSize="20" color="blue.400" />
				</Button>

				<Button
					size="sm"
					bg="transparent"
					_hover={{ bg: 'transparent' }}
					onClick={handleDeleteEnd}
				>
					<Icon as={FiTrash2} fontSize="20" color="red.500" />
				</Button> */}
			</Stack>
		</Stack>
	)
}

export default EnderecoItem;